import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';

import {
  CustomDateRangePicker,
  FormActionButtons,
  PopoverWrapper
} from 'components';

import HelpIcon from '@material-ui/icons/Help';

import { useStyles } from './styles';

const initialValues = {
  availability: {
    startDate: moment(),
    endDate: null
  }
};

const SchedulePass = ({
  onSubmit,
  handleSubmit,
  setSubmitButton,
  isUpdate,
  changeFieldValue
}) => {
  const classes = useStyles();

  const submit = values => {
    changeFieldValue('pricesFixedForm', 'USD', '0');
    changeFieldValue('pricesFixedForm', 'EUR', '0');
    changeFieldValue('pricesFixedForm', 'NOK', '0');
    onSubmit(values);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(submit)}>
        <div className={classes.row}>
          <div className={classes.datePickerWrapper}>
            <Field
              name="availability"
              label="Availability"
              component={CustomDateRangePicker}
            />
          </div>
          <PopoverWrapper text="If you don't select the timestamps, the activity will be available all the time">
            <HelpIcon className={classes.helpIcon} />
          </PopoverWrapper>
        </div>
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  changeFieldValue: (form, field, value) => {
    dispatch(change(form, field, value));
  }
});

export default reduxForm({
  form: 'schedulePassForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues
})(connect(null, mapDispatchToProps)(SchedulePass));
